<template>
  <div>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
      <v-layout wrap>
        <v-flex xs6>
          <v-card
            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
            class="mt-2"
          >
            <v-progress-linear
              :indeterminate="true"
              v-if="loading"
              color="success"
              class="mx-3"
            ></v-progress-linear>
            <v-layout row justify-space-between v-if="!loading">
              <v-layout column class="ma-1 px-3">
                <v-card-text
                  class="mb-0 pb-0 pt-2 pl-2"
                  v-if="donor && donor.personID"
                >
                  <div class="display-1 pt-2 font-weight-bold mb-0 ml-0">
                    {{ donor.nameH }}
                  </div>
                  <div class="ml-0 mt-4">
                    <div class="pl-3">
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Donor ID:
                        </div>
                        <div>
                          {{ donor.personID }}
                        </div>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Father:
                        </div>
                        <a class="" :href="donor.paternalGrandParentId">{{
                          donor.father
                        }}</a>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Father In Law:
                        </div>
                        <a class="" :href="donor.maternalGrandParentId">{{
                          donor.fatherInLaw
                        }}</a>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Address:
                        </div>
                        <div>
                          {{ donor.address1 }}
                        </div>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Email Address:
                        </div>
                        <div>
                          {{ donor.emailAddress }}
                        </div>
                      </v-layout>
                      <v-layout row class="mb-2" v-for="phone in phonesNumbers">
                        <div class="font-weight-medium mr-2">
                          {{ getPhoneType(phone.phoneType) }}:
                        </div>
                        <div>
                          {{ phone.phoneNum }}
                        </div>
                      </v-layout>
                    </div>
                  </div>
                </v-card-text>
              </v-layout>
            </v-layout>

            <v-spacer></v-spacer>
          </v-card>
        </v-flex>
        <v-flex xs6 fill-height>
          <v-card
            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
            class="mt-2 pa-3"
          >
            <v-progress-linear
              :indeterminate="true"
              v-if="loadingChildren"
              color="success"
            ></v-progress-linear>
            <div v-if="!loadingChildren">
              <v-layout row class="pl-2 pr-3">
                <div class="title pt-3">Children</div>
                <v-spacer></v-spacer>
                <v-btn @click="openAluminiDialog" color="success" small
                  >Connect Alumini</v-btn
                >
              </v-layout>
              <v-divider class="pt-2"></v-divider>
            </div>
            <div class="body-1" v-if="!loadingChildren && !allChildren.length">
              No Married Children
            </div>

            <div v-for="(child, index) in allChildren">
              <a class="" :href="child.link">{{ child.displayName }}</a>
              <div
                class="caption text-info"
                v-if="child.aluminiPersons && child.aluminiPersons.length"
              >
                {{ getAluminiPersons(child) }}
              </div>
              <v-divider
                class="pt-1 mt-1 "
                v-if="index + 1 < children.length"
              ></v-divider>
            </div>

            <v-spacer></v-spacer>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-2" v-if="!hasLimitedView()">
          <v-card
            class="pa-3 mt-0"
            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
          >
            <v-tabs color="success" dark icons-and-text>
              <v-tabs-slider color="#fff"></v-tabs-slider>

              <v-tab href="#donations">
                Donations ({{ transactions.length }})
                <v-icon>mdi-currency-usd</v-icon>
              </v-tab>

              <v-tab-item value="donations">
                <v-card-text
                  class="text-xs-center title mt-3"
                  v-if="!transactions.length"
                  >No Donations</v-card-text
                >

                <v-expansion-panel
                  v-if="transactions.length"
                  class="expansion-panel-margin mt-3"
                >
                  <v-expansion-panel-content
                    v-for="transaction in transactions"
                  >
                    <template v-slot:header>
                      <v-flex xs3 class="pl-0">
                        <v-layout row align-start class="pa-0 mx-0">
                          <v-layout column class="py-0 ma-0">
                            <v-flex xs3>
                              <v-layout row>
                                <v-icon
                                  class="mr-3"
                                  dark
                                  :color="getStatusIconColor(transaction)"
                                  >{{ getStatusIcon(transaction) }}</v-icon
                                >
                                <div>
                                  <div class="subheading mb-1">
                                    {{ transaction.dateTime | time }}
                                  </div>
                                  <div class="text--disabled subheading">
                                    {{ transaction.pmtType }}
                                  </div>
                                </div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs2>
                        <div class="body-2 font-weight-medium mb-1">
                          Source:
                        </div>
                        <div class="body-2 mb-1">
                          {{ transaction.source }}
                        </div>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs3>
                        <v-layout column align-end class="mx-0 pr-4">
                          <div
                            class="subheading mb-1"
                            v-bind:class="{
                              'text-danger': transaction.amount < 0,
                            }"
                          >
                            {{ transaction.amount | currency }}
                          </div>
                          <!-- <div
                                                    class="text--disabled subheading"
                                                >
                                                    {{ transaction.pmtType }}
                                                </div> -->
                        </v-layout>
                      </v-flex>
                    </template>
                    <v-card>
                      <v-flex xs12>
                        <v-card-text class="subheading mt-2">
                          <v-layout row class="px-3 py-2">
                            <div class="font-weight-medium mr-2 width-200">
                              Date:
                            </div>
                            <div>
                              {{ transaction.dateTime | time }}
                            </div>
                          </v-layout>
                          <v-layout row class="px-3 py-2">
                            <div class="font-weight-medium mr-2 width-200">
                              Amount:
                            </div>
                            <div>
                              {{ transaction.amount | currency }}
                            </div>
                          </v-layout>
                          <v-layout row class="px-3 py-2">
                            <div class="font-weight-medium mr-2 width-200">
                              Last Updated:
                            </div>
                            <div>
                              {{ transaction.lastUpdated | time }}
                            </div>
                          </v-layout>
                          <v-layout
                            row
                            class="px-3 py-2"
                            v-for="prop in getProperties(transaction)"
                          >
                            <div class="font-weight-medium mr-2 width-200">
                              {{ prop.name }}:
                            </div>
                            <div>
                              {{ prop.value }}
                            </div>
                          </v-layout>
                        </v-card-text>
                      </v-flex>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-tab-item>
              <v-tab href="#sales">
                Sales ({{ sales.length }})
                <v-icon>mdi-domain</v-icon>
              </v-tab>
              <v-tab-item value="sales">
                <dedication-sales-by-parson-tab
                  :initial-data="{ donor: donor }"
                  @dedication-sales="sales = $event"
                />
              </v-tab-item>
              <v-tab href="#communication">
                Communications ({{ commCount }})
                <v-icon>mdi-account-switch</v-icon>
              </v-tab>
              <v-tab-item value="communication">
                <dedication-communications
                  v-if="Array.isArray(sales)"
                  :initial-data="{ donor: donor, sales: sales }"
                  @update-comm-count="commCount = $event"
                />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="aluminiDialog" max-width="800">
      <v-card class="pa-3">
        <v-card-title class="headline px-0 pt-2">Alumini Mapping</v-card-title>
        <v-layout row>
          <v-flex xs6
            ><v-btn
              small
              color="success"
              class="mt-0"
              @click="openNewAluminiMapping"
              v-if="!newAluminiMapping.show"
              >New Mapping</v-btn
            >
            <div v-if="newAluminiMapping.show" class="pr-3">
              <v-select
                label="Student"
                :items="alumini"
                v-model="newAluminiMapping.student"
                @change="studentSelected"
                ref="student"
                :rules="[rules.required]"
                item-disabled="disabled"
                item-text="displayName"
                clearable
              ></v-select>
              <v-select
                label="Child"
                :items="children"
                item-text="displayName"
                v-model="newAluminiMapping.child"
                ref="child"
                :rules="[rules.required]"
                clearable
                :disabled="!newAluminiMapping.student"
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="data.item.displayName"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="data.item.mappingStatus"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
              <div class="text-info mb-2" v-if="getChildMapping()">
                {{ getChildMapping() }}
              </div>
              <v-select
                label="Type"
                :items="['Father', 'Mother']"
                disabled
                v-model="newAluminiMapping.type"
              ></v-select>
              <v-layout row>
                <v-spacer></v-spacer>
                <!-- <v-btn
                                    small
                                    color="default"
                                    dark
                                    class="mr-2"
                                    @click="closeNewAluminiMapping"
                                    >Cancel</v-btn
                                > -->
                <v-btn
                  :loading="processing"
                  dark
                  color="success"
                  small
                  @click="saveAlumini()"
                >
                  Save
                </v-btn>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="title">Mapped Alumini Persons</div>
            <div v-if="!getMappedAluminis().length" class="body-1 mb-0">
              No Mapped Alumini Persons
            </div>
            <div v-for="(alumini, index) in getMappedAluminis()">
              <v-layout row>
                <div style="padding-top: 9px;">
                  {{ alumini.displayName }}
                </div>
                <v-btn
                  class="my-0 py-0"
                  @click.stop="openDeleteMappedAluminiDialog(alumini)"
                  flat
                  icon
                  color="success"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-layout>
              <v-divider
                class="pt-1 mt-1 "
                v-if="index + 1 < getMappedAluminis().length"
              ></v-divider>
            </div>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-0 mr-2 mt-3">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="aluminiDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="deleteMappedDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="text-warning headline">Are You Sure?</v-card-title>
        <v-card-text class="mb-3 py-0">
          You will delete the mapping of
          {{ aluminiToDelete.displayName }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteMappedDialog = false"
            >Close</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="deleteAluminiMapping()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  groupBy,
  formatPhoneNumber,
  toTitleCase,
  except,
} from "../../utils/helpers.js";
import moment from "moment";
import DedicationSalesByParsonTab from "../DediPro/DedicationSalesByParsonTab.vue";
import DedicationCommunications from "../DediPro/DedicationCommunications.vue";
export default {
  components: {
    DedicationSalesByParsonTab,
    DedicationCommunications,
  },
  data: () => ({
    donor: null,
    phonesNumbers: [],
    transactions: [],
    children: [],
    allChildren: [],
    alumini: [],
    processing: false,
    loading: true,
    loadingChildren: true,
    aluminiDialog: false,
    limitedView: false,
    deleteMappedDialog: false,
    aluminiToDelete: {},
    sales: "",
    commCount: 0,
    newAluminiMapping: {
      show: true,
      student: "",
      child: "",
      type: "",
    },

    rules: {
      required: (v) => {
        return !!v || "Required";
      },
    },
  }),
  async created() {
    if (this.$route.query.limitView) {
      this.limitedView = true;
    }

    await this.load();
  },
  methods: {
    async load() {
      await this.loadDonor();
    },
    async loadDonor() {
      const donor = await this.$http.get(
        "api/donors/getDonor?personID=" + this.$route.params.id
      );

      this.donor = donor;
      this.loading = false;

      this.loadPhones();
      this.loadTransactions();
      await this.loadChildren();
      await this.loadAlumini();

      if (this.$route.query.aluminiStudent) {
        this.openAluminiDialog(this.$route.query.aluminiStudent);
      }
    },
    async loadPhones() {
      const phones = await this.$http.get(
        "api/donors/GetPhones?personID=" + this.$route.params.id
      );

      this.phonesNumbers = phones;
    },
    async loadTransactions() {
      const transactions = await this.$http.get(
        "api/donors/GetTransactions?personID=" + this.$route.params.id
      );

      this.transactions = transactions;
    },
    async loadChildren() {
      const children = await this.$http.get(
        "api/donors/GetChildren?personID=" + this.$route.params.id
      );

      this.allChildren = children.map((child) => {
        child.link = "/dinner/dinner-account-view/" + child.personID;
        child.displayName =
          child.titleHebrew +
          " " +
          child.firstHebrew +
          " " +
          child.lastHebrew +
          " " +
          child.suffixHebrew +
          " (" +
          child.weddingYear +
          ")";

        child.mappingStatus = this.getChildMapping(child);

        return child;
      });

      this.children = this.allChildren;

      this.loadingChildren = false;

      this.$forceUpdate();
    },
    async loadAlumini() {
      if (!this.donor.parentId) return;

      const alumini = await this.$http.get(
        "api/donors/GetAlumini?parentId=" + this.donor.parentId
      );

      this.alumini = alumini.map((a) => {
        const isMapped = this.children.find((child) => {
          if (!child.aluminiPersons) return false;

          const aluminiPerson = child.aluminiPersons.find(
            (c) => c.studentID == a.studentID
          );

          return !!aluminiPerson;
        });

        a.disabled = isMapped;

        a.displayName =
          (a.firstHebrew ? a.firstHebrew : "Student ID: " + a.studentID) +
          " (" +
          a.class +
          ") | " +
          a.regID +
          (isMapped ? " | MAPPED" : "");

        return a;
      });
    },
    hasLimitedView() {
      if (this.limitedView) return true;

      const roles = Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];

      return roles.includes("Alumini");
    },
    getPhoneType(phoneType) {
      switch (phoneType) {
        case "PHON":
          return "Home Phone";
        case "CEL":
          return "Cellphone";
        case "MCEL":
          return "Mother Cellphone";
      }
    },
    getProperties(transaction) {
      return Object.keys(
        except(transaction, "dateTime", "amount", "lastUpdated", "cCnum")
      )
        .map((key) => {
          return {
            name: toTitleCase(key),
            value: transaction[key],
          };
        })
        .filter((p) => p.value);
    },
    getStatusIcon(payment) {
      return "mdi-currency-usd";
    },
    getStatusIconColor(transaction) {
      return transaction.pmtType == "Pledge" ? "info" : "success";
    },
    openAluminiDialog(aluminiStudent) {
      if (aluminiStudent) {
        const student = this.alumini.find((a) => a.studentID == aluminiStudent);

        if (!student) {
          this.aluminiDialog = true;

          return;
        }

        this.newAluminiMapping.student = student.displayName;
        this.newAluminiMapping.child = "";
        this.studentSelected(student.displayName);
        this.newAluminiMapping.show = true;
      } else {
        this.newAluminiMapping.student = "";
        this.newAluminiMapping.child = "";
        this.newAluminiMapping.type = "";
        this.newAluminiMapping.show = true;
      }

      this.aluminiDialog = true;
    },
    openNewAluminiMapping() {
      this.newAluminiMapping.student = "";
      this.newAluminiMapping.child = "";
      this.newAluminiMapping.type = "";

      this.newAluminiMapping.show = true;
    },
    closeNewAluminiMapping() {
      this.newAluminiMapping.student = "";
      this.newAluminiMapping.child = "";
      this.newAluminiMapping.type = "";
      this.$refs.student.resetValidation();
      this.$refs.child.resetValidation();

      this.newAluminiMapping.show = true;
    },
    studentSelected(value) {
      if (value) {
        const student = this.alumini.find((s) => s.displayName == value);

        this.newAluminiMapping.type =
          student.class.startsWith("B-") || student.class.startsWith("Y-")
            ? "Father"
            : "Mother";

        this.children =
          this.newAluminiMapping.type == "Father"
            ? this.allChildren.filter((c) => c.childType == "SON")
            : this.allChildren.filter((c) => c.childType == "SON IN LAW");
      } else {
        this.newAluminiMapping.child = "";
        this.children = this.allChildren;
      }
    },
    getMappedAluminis() {
      return this.allChildren
        .map((child) => {
          return child.aluminiPersons.map((aluminiPerson) => {
            return {
              displayName: child.displayName + " - " + aluminiPerson.type,
              id: aluminiPerson.id,
            };
          });
        })
        .flat();
    },
    openDeleteMappedAluminiDialog(alumini) {
      this.aluminiToDelete = alumini;

      this.deleteMappedDialog = true;
    },
    async deleteAluminiMapping() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/donors/deleteAluminiPerson?id=" + this.aluminiToDelete.id
        );

        this.processing = false;
        this.deleteMappedDialog = false;

        await this.loadChildren();
        this.loadAlumini();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveAlumini() {
      if (
        !this.$refs.student.validate(true) ||
        !this.$refs.child.validate(true)
      )
        return;

      const student = this.alumini.find(
        (s) => s.displayName == this.newAluminiMapping.student
      );

      if (student.disabled) {
        return this.$notify({
          group: "notification",
          text: "Student disabled",
          type: "error",
        });
      }

      const child = this.children.find(
        (s) => s.displayName == this.newAluminiMapping.child
      );

      try {
        await this.$http.post("api/donors/SaveAluminiPerson", {
          personID: child.personID,
          studentID: student.studentID,
          type: this.newAluminiMapping.type,
          createdBy: this.$store.state.authentication.user,
        });

        this.$notify({
          text: "Mapping Saved",
          group: "notification",
          type: "success",
        });

        this.closeNewAluminiMapping();

        this.processing = false;

        await this.loadChildren();
        this.loadAlumini();
      } catch (e) {
        this.processing = false;
      }
    },
    getChildMapping(child = null) {
      if (!child) {
        if (!this.newAluminiMapping.child) return;

        child = this.children.find(
          (s) => s.displayName == this.newAluminiMapping.child
        );
      }

      if (!child.aluminiPersons.length) return;

      if (child.aluminiPersons.length == 2) {
        let text = "";

        child.aluminiPersons.forEach((aluminiPerson) => {
          const student = child.aluminiPersonStudents.find(
            (s) => s.studentID == aluminiPerson.studentID
          );

          text += "" + aluminiPerson.type + " Mapped" + " ";
        });

        return text;
      }

      const aluminiPerson = child.aluminiPersons[0];

      const student = child.aluminiPersonStudents.find(
        (s) => s.studentID == aluminiPerson.studentID
      );

      return aluminiPerson.type + " Mapped";
    },
    getAluminiPersons(child) {
      if (!child.aluminiPersons.length) return;

      if (child.aluminiPersons.length == 2) {
        let text = "";

        child.aluminiPersons.forEach((aluminiPerson) => {
          const student = child.aluminiPersonStudents.find(
            (s) => s.studentID == aluminiPerson.studentID
          );

          text +=
            "● " +
            aluminiPerson.type +
            " Mapped" +
            (student
              ? " to " +
                student.firstHebrew +
                " " +
                student.lastHebrew +
                " (" +
                student.class +
                " | " +
                student.regID +
                ")"
              : "") +
            " ";
        });

        return text;
      }

      const aluminiPerson = child.aluminiPersons[0];

      const student = child.aluminiPersonStudents.find(
        (s) => s.studentID == aluminiPerson.studentID
      );

      return (
        "● " +
        aluminiPerson.type +
        " Mapped" +
        (student
          ? " to " +
            student.firstHebrew +
            " " +
            student.lastHebrew +
            " (" +
            student.class +
            " | " +
            student.regID +
            ")"
          : "")
      );
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}
.distribution-list {
  border: 1px solid #ddd !important;
}
.spacail-needs-link {
  color: rgb(76, 175, 80);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}
.expansion-panel-margin .v-expansion-panel__header {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
